module.exports = "//static.hsappstatic.net/LoginUI/static-1.13288/img/chatspot-icon.png"